/* eslint-disable linebreak-style */
import { createSlice } from '@reduxjs/toolkit';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const defaultLocale = publicRuntimeConfig.APP_LOCALE || 'es';

const initialState = {
  locale: defaultLocale
};

const locale = createSlice({
  name: 'locale',
  initialState,
  reducers: {
    setLocale(state, { payload }) {
      state.locale = payload;
    },
  },
});

export const {
  setLocale
} = locale.actions;

export default locale.reducer;

export const changeLocale = (newLocale) => setLocale(newLocale);
